import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "errorMessage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "signup-view__container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center my-5" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "You do not have permissions to view this page."),
    /*#__PURE__*/_createElementVNode("p", null, "Contact your organization’s Ditto account administrator.")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}